import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useExchangeToken from './useExchangeToken';

export default function useCheckToken() {
  const exchangeToken = useExchangeToken();
  const { isLogin, accessToken, access_token, rb_ac_exp } = useSelector(state => state.auth);
  useEffect(() => {
    if (!isLogin || !accessToken) return undefined;
    let timer;
    let active = true;
    const refresh = async () => {
      const token = await exchangeToken();
      if (active && !token) timer = setTimeout(refresh, 30000);
    };
    const delay = access_token && rb_ac_exp
      ? Math.max(0, (rb_ac_exp - Date.now() / 1000 - 60) * 1000) : 0;
    timer = setTimeout(refresh, Math.min(delay, 2147483647));
    return () => { active = false; clearTimeout(timer); };
  }, [isLogin, accessToken, access_token, rb_ac_exp, exchangeToken]);
}
